import { Tokens } from '@/assets/tokens'
import { Button, Flex, SelectionOption, Selector } from '@/components'
import { Alert, Api } from '@/modules'
import { Close } from '@icon-park/react'
import { useEffect, useState } from 'react'
import { AddThemeContainer, AddThemeOverlay } from './EditModal.styles'

interface AddSpokespersonModalProps {
  companyID: string
  brandID: string
  currentSpokespersons: string[]
  onCancel: () => void
  onAdd: (internalID: string, name: string) => void
}

export function AddSpokespersonModal({
  companyID,
  brandID,
  currentSpokespersons,
  onCancel,
  onAdd,
}: AddSpokespersonModalProps): JSX.Element {
  const { sendAlert } = Alert.Hook()

  const [availableSpokespersons, setAvailableSpokespersons] = useState<SelectionOption[]>([])

  const { binder: bindSpokesperson, selectedOption: selectedSpokesperson } = Selector.Binder()

  const [fetchSpokespersons, isLoadingSpokespersons, spokespersonsData] = Api.LazyQuery<any>(`spokespersons/search`)

  useEffect(() => {
    fetchSpokespersons({
      company: companyID,
      size: 10000,
      brandIDs: [brandID],
    })
  }, [fetchSpokespersons, companyID, brandID])

  useEffect(() => {
    if (spokespersonsData && Array.isArray(spokespersonsData)) {
      const filtered = spokespersonsData
        .filter((sp: any) => {
          const isAlreadyUsed = currentSpokespersons.includes(sp.value)
          return !isAlreadyUsed
        })
        .map((sp: any) => ({
          text: sp.text,
          value: sp.value,
        }))

      setAvailableSpokespersons(filtered)
    }
  }, [spokespersonsData, currentSpokespersons])

  const handleAdd = () => {
    if (!selectedSpokesperson) {
      sendAlert({
        type: 'error',
        title: 'Seleção incompleta',
        message: 'Por favor, selecione uma mensagem-chave.',
      })
      return
    }

    const selectedMessage = availableSpokespersons.find((sp) => sp.value === selectedSpokesperson.value)?.text || ''

    onAdd(String(selectedSpokesperson.value), selectedMessage)
  }

  return (
    <AddThemeOverlay>
      <AddThemeContainer>
        <Flex $type="row" $justify="center" $align="center" $fit style={{ position: 'relative' }}>
          <h3 style={{ margin: 0, textAlign: 'center', flex: 1 }}>Adicionar Porta-voz</h3>
          <Button.Root $variant="link" onClick={onCancel} style={{ position: 'absolute', right: 0 }}>
            <Button.Icon value={Close} color={Tokens.ColorTextPrimary} />
          </Button.Root>
        </Flex>

        <Flex $type="column" $justify="center" $align="center" $fit $gap={16}>
          <Selector.Default
            {...bindSpokesperson}
            placeholder="Selecionar porta-voz"
            options={availableSpokespersons}
            loading={isLoadingSpokespersons}
          />

          {availableSpokespersons.length === 0 && !isLoadingSpokespersons && (
            <p style={{ color: Tokens.ColorTextTertiary, fontSize: '14px', textAlign: 'center', margin: 0 }}>
              Todos os porta-vozes já estão associados há essa postagem
            </p>
          )}
        </Flex>

        <Flex $type="row" $justify="center" $align="center" $fit $gap={16}>
          <Button.Root $variant="secondary" onClick={onCancel} style={{ width: '7rem' }}>
            <Button.Text value="Cancelar" />
          </Button.Root>
          <Button.Root
            $variant="primary"
            onClick={handleAdd}
            style={{ width: '7rem' }}
            disabled={!selectedSpokesperson || availableSpokespersons.length === 0}>
            <Button.Text value="Adicionar" />
          </Button.Root>
        </Flex>
      </AddThemeContainer>
    </AddThemeOverlay>
  )
}
